import { render, staticRenderFns } from "./Onboardings.vue?vue&type=template&id=8f396548&scoped=true&"
import script from "./Onboardings.vue?vue&type=script&lang=js&"
export * from "./Onboardings.vue?vue&type=script&lang=js&"
import style0 from "./Onboardings.vue?vue&type=style&index=0&id=8f396548&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f396548",
  null
  
)

export default component.exports